<template>
  <div class="login">
    <form class="" method="post" @submit.prevent="submit">
      <header-text :label="$t('account')" :title="$t('login')" />

      <field-input
        v-model="email"
        :label="$t('email')"
        name="email"
        :v="$v.email"
      />
      <field-input
        v-model="password"
        :label="$t('password')"
        name="password"
        type="password"
        :v="$v.password"
      />

      <div class="form-column form-column__remember-password">
        <!-- <checkbox label="Rember me" name="remember">Remember me</checkbox> -->
        <div class="recovery">
          <div class="recovery__text">
            <span class="recovery__label">{{ $t("forgot_password") }}</span>
            <span class="recovery__links">
              <a
                :href="recoveryPasswordUrl"
                id="login-recovery"
                target="_blank"
                class="recovery__link"
                pad-down="go:#login-back"
                pad-a="click"
              >
                {{ $t("click_here") }}
              </a>
            </span>
          </div>
        </div>
      </div>

      <div class="form-column form-column--buttons">
        <r-button-submit
          :label="$t('login')"
          color="white"
          id="login-submit"
          pad-right="go:#login-back"
          pad-down="go:#login-create"
          pad-up="go:#login-recovery"
        />
        <button-back
          v-if="$route.path === '/login'"
          :label="$t('back')"
          color="white"
          @click="backButton()"
          id="login-back"
          pad-start
          pad-a="click"
          pad-left="go:#login-submit"
          pad-down="go:#login-create"
          pad-up="go:#login-recovery"
        />
      </div>
      <required-label />
    </form>

    <div class="new-user">
      <span class="new-user__label">{{ $t("new_here") }}</span>
      <button-back
        :label="$t('create_an_account')"
        id="login-create"
        pad-up="go:#login-submit"
        pad-a="click"
        color="white"
        @click="$emit('accountCreate')"
      />
      <!-- <button-back
        v-if="$route.name == 'Onboarding'"
        label="Create an account"
        color="white"
        @click="$emit('accountCreate')"
      />
      <a v-else :href="createAccountUrl" class="btn" target="_blank">
        Create an account
      </a> -->
    </div>
  </div>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import Gamepad from "@/utils/gamepadInit";

export default {
  components: {},
  data() {
    return {
      email: null,
      password: null,
      recoveryPasswordUrl: `${process.env.VUE_APP_ACCOUNT_API_URL}account/forgot-password`,
      createAccountUrl: `${process.env.VUE_APP_ACCOUNT_API_URL}account/create`
    };
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(8)
    }
  },
  methods: {
    backButton() {
      const game = this.$route.query.game;
      // console.log("query", this.$route.query);
      // console.log(game);
      if (game) {
        this.$router.push({ name: `${game}` });
      } else {
        this.$router.push({ name: `bg3` });
      }
    },
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit("submit", {
          email: this.email,
          password: this.password
        });
      }
    }
  },

  created() {
    Gamepad();
  }
};
</script>

<style lang="scss" scoped>
.login {
  // width: 500px;
  // margin: 0 auto;
  .labels {
    margin-top: 10px;
    justify-content: flex-end;
  }
}

.login-form {
  display: flex;
  flex-direction: column;
}

.form-column {
  display: flex;
  // flex-direction: column-reverse;
  justify-content: space-between;

  &__remember-password {
    margin-bottom: 20px;
    justify-content: flex-end;

    .form-field {
      margin: 0;
    }
  }
}

.form-column--buttons {
  align-items: center;
}

.recovery {
  @include fontSizes(16px, 14px, 14px, 16px, 16px);

  display: flex;
  // margin-bottom: 30px;
  align-items: center;

  &__text {
    display: flex;
  }

  &__label {
    color: $white-60;
    margin-right: 12px;
  }
  &__link {
    text-decoration: underline;
    color: $white;
  }
}

.new-user {
  margin-top: 30px;
  padding: 30px 0;
  border-top: 1px solid $white-20;
  display: flex;
  justify-content: center;
  align-items: center;

  &__label {
    color: $white-60;
    margin-right: 35px;
  }

  .btn {
    margin: 0;
  }
}

@media screen and (min-width: $screen-md) {
  .form-column {
    flex-direction: row;
    justify-content: space-between;

    &__remember-password {
      justify-content: flex-end;
    }

    button[type="submit"] {
      // width: 20rem;
      margin-right: 20px;
    }
  }

  .recovery {
    margin-bottom: 0;
    &__icon {
      width: 3rem;
    }
  }
}
</style>
